import { FetchResult } from '@apollo/client'
import { ServiceDependencies } from 'lib/core/services/magento'
import { apolloClient } from 'lib/core/services/magento/client'
import gql from 'graphql-tag'
import { jsonToGraphQLQuery } from 'lib/core/resources/helpers/jsonToGraphql'

export interface AddWishlistItemMutationObject {
  mutation: {
    addWishlistItem: {
      __args: {
        input: {
          sku: string
        }
      }
      Item: {
        id: boolean
      }
    }
  }
}

export const addWishlistItemMutationObject: AddWishlistItemMutationObject = {
  mutation: {
    addWishlistItem: {
      __args: {
        input: {
          sku: ''
        }
      },
      Item: {
        id: true
      }
    }
  }
}

interface AddWishlistItemMutationInput {
  sku: string
}

export type AddWishlistItemMutation = (input: AddWishlistItemMutationInput) => Promise<FetchResult<any>>

export const createAddWishlistItemMutation = ({ getMutations }: ServiceDependencies): AddWishlistItemMutation => async ({ sku }) => {
  const mutation = getMutations().addWishlistItemMutation
  mutation.mutation.addWishlistItem.__args.input.sku = sku

  return apolloClient.mutate({
    mutation: gql`${jsonToGraphQLQuery(mutation)}`
  })
}
